import {
  FETCH_SHARE_TEMPLATE,
  FETCHING_SHARE_TEMPLATE_SUCCEEDED,
  FETCHING_SHARE_TEMPLATE_FAILED,
  UPDATE_SHARE_TEMPLATE,
  UPDATING_SHARE_TEMPLATE_SUCCEEDED,
  UPDATING_SHARE_TEMPLATE_FAILED,
  INVALIDATE_SHARE_SETTINGS_UPDATE,
  REPHARSE_LINKEDIN_POST,
  REPHARSING_LINKEDIN_POST_SUCCEEDED,
  REPHARSING_LINKEDIN_POST_FAILED,
  INVALIDATE_LINKEDIN_POST_TONES
} from './actionTypes';
import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import buildUrl from 'build-url-ts';
import { takeEvery, takeLatest, call, put } from "redux-saga/effects";
import { IFetchShareTemplateErrorResponse, IFetchShareTemplateRequest, IFetchShareTemplateResponse, IInvalidShareSettingsUpdate, IRephraseRequest, IRephraseErrorResponse, IRephraseResponse, IShareTemplate, IUpdateShareTemplateErrorResponse, IUpdateShareTemplateRequest, IUpdateShareTemplateResponse } from 'src/types/shareTemplate';

const apiUrl = process.env.REACT_APP_API_URL;
const API_BASE_URL = `${apiUrl}/api/2.0`;
const SHARE_SETTINGS_URL = `${API_BASE_URL}/share-template`

export const fetchShareTemplate = createAction<IFetchShareTemplateRequest>(FETCH_SHARE_TEMPLATE);
const fetchingShareTemplateSucceeded = createAction<IFetchShareTemplateResponse>(FETCHING_SHARE_TEMPLATE_SUCCEEDED);
const fetchingShareTemplateFailed = createAction<IFetchShareTemplateErrorResponse>(FETCHING_SHARE_TEMPLATE_FAILED);

const fetchShareTemplateSaga = function* (action: ReturnType<typeof fetchShareTemplate>): any {
  const id = action.payload.entityId;
  const entityType = action.payload.entityType;
  const templateType = action.payload.templateType;

  const url = buildUrl(`${SHARE_SETTINGS_URL}/${id}`, {
    queryParams: {
      type: entityType,
      templateType: templateType
    }
  })

  const fetchShareTemplateAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchShareTemplateAPI);
    yield put(fetchingShareTemplateSucceeded({
      response,
      entityId: id,
      entityType: entityType
    }));
  } catch (error) {
    yield put(fetchingShareTemplateFailed({
      error,
      entityId: id,
      entityType: entityType
    }));
  }
}

export const invalidateShareSettingsUpdate = createAction<IInvalidShareSettingsUpdate>(INVALIDATE_SHARE_SETTINGS_UPDATE);

export const updateShareTemplate = createAction<IUpdateShareTemplateRequest>(UPDATE_SHARE_TEMPLATE);
const updatingShareTemplateSucceeded = createAction<IUpdateShareTemplateResponse>(UPDATING_SHARE_TEMPLATE_SUCCEEDED);
const updatingShareTemplateFailed = createAction<IUpdateShareTemplateErrorResponse>(UPDATING_SHARE_TEMPLATE_FAILED);

const updateShareTemplateSaga = function* (action: ReturnType<typeof updateShareTemplate>): any {

  const id = action.payload.entityId;
  const entityType = action.payload.entityType;
  const requestBody = action.payload.requestBody;

  const url = buildUrl(`${SHARE_SETTINGS_URL}/${id}`, {
    queryParams: {
      type: entityType
    }
  })

  const updateShareTemplateAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: requestBody
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateShareTemplateAPI);
    yield put(updatingShareTemplateSucceeded({
      response,
      entityId: id,
      entityType: entityType
    }));
  } catch (error) {
    yield put(updatingShareTemplateFailed({
      error,
      entityId: id,
      entityType: entityType
    }));
  }
}

export const invalidateLinkedInPostTones = createAction<{ entityId : string }>(INVALIDATE_LINKEDIN_POST_TONES);

export const repharseLinkedInPostDescription = createAction<IRephraseRequest>(REPHARSE_LINKEDIN_POST);
const repharsingLinkedInPostDescriptionSucceeded = createAction<IRephraseResponse>(REPHARSING_LINKEDIN_POST_SUCCEEDED);
const repharsingLinkedInPostDescriptionFailed = createAction<IRephraseErrorResponse>(REPHARSING_LINKEDIN_POST_FAILED);

const repharseLinkedInPostDescriptionSaga = function* (action: ReturnType<typeof repharseLinkedInPostDescription>): any {
  const { message, entityId, rephraseTone  } = action.payload;

  const url = buildUrl(`${SHARE_SETTINGS_URL}/rephrase`)

  const rephraseToneApi = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        message: message,
        rephraseTone: rephraseTone
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(rephraseToneApi);
    yield put(repharsingLinkedInPostDescriptionSucceeded({
      response,
      entityId: entityId,
      rephraseTone: rephraseTone
    })); 
  } catch (error) {
    yield put(repharsingLinkedInPostDescriptionFailed({
      error,
      entityId: entityId,
      rephraseTone: rephraseTone
    }));
  }
}

export default function* shareTemplatesSaga() {
  yield takeLatest(FETCH_SHARE_TEMPLATE, fetchShareTemplateSaga);
  yield takeLatest(UPDATE_SHARE_TEMPLATE, updateShareTemplateSaga);
  yield takeLatest(REPHARSE_LINKEDIN_POST, repharseLinkedInPostDescriptionSaga);
}